export default "__VITE_ASSET__DHqIa8BB__";